import Form from "./Form";
import { useToast } from "@chakra-ui/react";
import {
  CreateStaffMutationVariables,
  useCreateStaffMutation,
} from "../../generated/graphql";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const [createUser] = useCreateStaffMutation();
  const navigation = useNavigate();
  const toast = useToast();
  const handleCreateUser = async (data: CreateStaffMutationVariables) => {
    try {
      await createUser({
        variables: {
          data: data.data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Yetkili oluşturuldu",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/staff");
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };
  return <Form handleCreateUser={handleCreateUser} actionType="CREATE" />;
};

export default Create;
